import FeatureGates from '@atlaskit/feature-gate-js-client';

import { STATSIG_END_OF_TRIAL_GATE } from '../experimentConstants';

const isFeatureEnabled = () => FeatureGates.checkGate(STATSIG_END_OF_TRIAL_GATE);

export const isEotEnabled = () => !!isFeatureEnabled();
